import {
  formatNormalNumber,
  createKpiTileItem,
  formatPercentageValue,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { totalAlerts, totalAlertsPercentageDelta = 0 } = data || {};

    return createKpiTileItem(
      'Total Alerts Sent Out',
      formatNormalNumber(totalAlerts),
      Number(totalAlertsPercentageDelta) !== 0
        ? {
            isPositiveValue: totalAlertsPercentageDelta >= 0,
            text: formatPercentageValue(Math.abs(totalAlertsPercentageDelta)),
            sideLabel: '',
          }
        : null
    );
  },
};
